define("shared/components/shared/modal/navigation", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "shared/components/shared/ui/navigation-arrows", "@ember/template-factory"], function (_exports, _component, _service, _component2, _navigationArrows, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"shared/components/shared/ui/navigation-arrows",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Ui::NavigationArrows @navigate={{@navigate}} @navigationModel={{@navigationModel}} />
  */
  {
    "id": "lt58nrgF",
    "block": "[[[8,[39,0],null,[[\"@navigate\",\"@navigationModel\"],[[30,1],[30,2]]],null]],[\"@navigate\",\"@navigationModel\"],false,[\"shared/ui/navigation-arrows\"]]",
    "moduleName": "shared/components/shared/modal/navigation.hbs",
    "isStrictMode": false
  });
  let NavigationComponent = _exports.default = (_class = class NavigationComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "secondaryModal", _descriptor, this);
      _initializerDefineProperty(this, "mediaNavigation", _descriptor2, this);
      _initializerDefineProperty(this, "postNavigation", _descriptor3, this);
      _defineProperty(this, "LEFT_ARROW", [37, 'ArrowLeft']);
      _defineProperty(this, "RIGHT_ARROW", [39, 'ArrowRight']);
      this.boundKeyHandler = this._keyHandler.bind(this);
      document.addEventListener('keyup', this.boundKeyHandler);
    }
    get navigationService() {
      return this.args.navigationModel === _navigationArrows.NavigableTypes.Media ? this.mediaNavigation : this.postNavigation;
    }
    willDestroy() {
      super.willDestroy(...arguments);
      document.removeEventListener('keyup', this.boundKeyHandler);
    }
    _keyHandler(event) {
      const key = event.key || event.keyCode;
      const interactiveElements = ['A', 'BUTTON', 'INPUT', 'TEXTAREA'];

      // Note: Ignore arrow key inputs if interactive elements are focused
      if (interactiveElements.includes(document.activeElement.tagName)) {
        return;
      }

      // Note: Disable arrow controls when secondary modal is open
      if (this.secondaryModal.isModalOpen()) {
        return;
      }

      // Note: Only 'navigate' if the arrow is visible
      if (this.LEFT_ARROW.includes(key) && !this.navigationService.firstNavigableItem) {
        this.args.navigate(false);
      }
      if (this.RIGHT_ARROW.includes(key) && !this.navigationService.lastNavigableItem) {
        this.args.navigate(true);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "secondaryModal", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "mediaNavigation", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "postNavigation", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, NavigationComponent);
});